export default {"src":"/_next/static/media/signin-img.f10df537.svg","height":344,"width":574};